import axios from "axios";
import { apiPath } from "constants/index";

const CLICK_ENDPOINT = "/api/landing/notification-click/";

/**
 * Tell the backend a notification deep link was opened.
 *
 * Fire-and-forget by design: this page redirects into the app moments after mount, so the
 * request must never delay or block that, and its result is never rendered - which is why this
 * is a plain function rather than the useMutation/useApiCall hooks (both set React state on
 * completion, on a component that is already unmounting). sendBeacon is preferred where
 * available because the browser guarantees it survives the redirect; axios is the fallback.
 * Failures are swallowed: a lost click metric must never stop a parent opening the app.
 */
export const recordNotificationClick = (notificationUuid: string | null) => {
  if (!notificationUuid || !apiPath) {
    return;
  }

  const url = `${apiPath}${CLICK_ENDPOINT}`;
  const payload = { notification_uuid: notificationUuid };

  try {
    if (navigator.sendBeacon) {
      const body = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });

      if (navigator.sendBeacon(url, body)) {
        return;
      }
    }

    void axios
      .post(url, payload, { headers: { "Content-Type": "application/json" } })
      .catch(() => undefined);
  } catch {
    // Never let click tracking break opening the app.
  }
};
